module.exports = __webpack_public_path__ + "static/media/curriculum_s2.2ddca93d.png";